import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["color", "contrast", "variant"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Typography as MuiTypography } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
export var Typography = function Typography(_ref) {
  var color = _ref.color,
    contrast = _ref.contrast,
    variant = _ref.variant,
    props = _objectWithoutProperties(_ref, _excluded);
  var transformColor = !color || color === 'inherit' ? color : contrast ? "".concat(color, ".contrastText") : "".concat(color, ".main");
  return /*#__PURE__*/_jsx(MuiTypography, _objectSpread(_objectSpread({}, props), {}, {
    color: transformColor,
    variant: variant
  }));
};